import { render, staticRenderFns } from "./model-field-editor.vue?vue&type=template&id=1e567c43&scoped=true"
import script from "./model-field-editor.vue?vue&type=script&lang=js"
export * from "./model-field-editor.vue?vue&type=script&lang=js"
import style0 from "./model-field-editor.vue?vue&type=style&index=0&id=1e567c43&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e567c43",
  null
  
)

export default component.exports